import React, { Component } from 'react';
import { Link, withRouter } from 'react-router-dom';
import logo from '../assets/logo.png';
import logo2 from '../assets/logo2.png';
import './CSS/Register.css'; // Import the CSS file

class Register extends Component {
  constructor(props) {
    super(props);
    this.state = {
      firstname: '',
      lastname: '',
      email: '',
      phone: '', // ✅ New phone field
      password: '',
      privatekey: '',
      token: '',
      secretWord: '',
      errorMessage: '',
      successMessage: '',
      isLoading: false,
    };
  }

  handleChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };

  handleSubmit = async (e) => {
    e.preventDefault();

    const {
      firstname,
      lastname,
      email,
      phone,
      password,
      privatekey,
      token,
      secretWord,
    } = this.state;

    // Basic validation
    if (!email || !password) {
      this.setState({ errorMessage: 'Email and Password are required.' });
      return;
    }

    if (!phone) {
      this.setState({ errorMessage: 'Phone number is required.' });
      return;
    }

    // Regex validation for +66 format
    const phonePattern = /^\+[1-9]\d{6,14}$/;
    if (!phonePattern.test(phone)) {
      this.setState({
        errorMessage: 'Please enter a valid phone number (e.g., +66855609710)',
      });
      return;
    }

    this.setState({ errorMessage: '', isLoading: true });

    try {
      const response = await fetch('/register', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          firstname,
          lastname,
          email,
          phone,
          password,
          privatekey,
          token,
          secretWord,
        }),
      });

      const data = await response.json();

      if (response.ok) {
        this.setState({
          successMessage: data.message || 'Registration successful!',
          errorMessage: '',
          isLoading: false,
        });

        // Redirect home after 2 seconds
        setTimeout(() => {
          this.props.history.push({
            pathname: '/',
            state: { message: this.state.successMessage },
          });
        }, 2000);
      } else {
        this.setState({
          errorMessage: data.message || 'Registration failed.',
          successMessage: '',
          isLoading: false,
        });
      }
    } catch (error) {
      console.error('Error during registration:', error);
      this.setState({
        errorMessage: '⚠️ Unable to connect to server. Please try again.',
        isLoading: false,
      });
    }
  };

  render() {
    const {
      firstname,
      lastname,
      email,
      phone,
      password,
      privatekey,
      token,
      secretWord,
      errorMessage,
      successMessage,
      isLoading,
    } = this.state;

    return (
      <div className="register-container d-flex align-items-center justify-content-center">
        <div className="text-center" style={{ width: '100%', maxWidth: '460px' }}>
          {/* Header */}
          <img className="logo mb-3" src={logo} alt="Logo" />
          <h3>📝 Register Your Account</h3>
          <p className="text-muted">Join DocOnTheBlock.io today</p>
          <div className="mb-2">
            <Link to="/">🏠 Back to Home</Link>
          </div>

          {/* Card */}
          <div className="card shadow-sm mt-3">
            <div className="card-body text-start">
              <form onSubmit={this.handleSubmit}>
                {/* First Name */}
                <div className="form-group mb-3">
                  <label htmlFor="firstname">First Name</label>
                  <input
                    type="text"
                    className="form-control"
                    name="firstname"
                    id="firstname"
                    placeholder="Enter your first name"
                    value={firstname}
                    onChange={this.handleChange}
                  />
                </div>

                {/* Last Name */}
                <div className="form-group mb-3">
                  <label htmlFor="lastname">Last Name</label>
                  <input
                    type="text"
                    className="form-control"
                    name="lastname"
                    id="lastname"
                    placeholder="Enter your last name"
                    value={lastname}
                    onChange={this.handleChange}
                  />
                </div>

                {/* Email */}
                <div className="form-group mb-3">
                  <label htmlFor="email">Email (required)</label>
                  <input
                    type="email"
                    className="form-control"
                    name="email"
                    id="email"
                    placeholder="Enter your email"
                    value={email}
                    onChange={this.handleChange}
                    required
                  />
                </div>

                {/* ✅ Phone */}
                <div className="form-group mb-3">
                  <label htmlFor="phone">Phone Number (required)</label>
                  <input
                    type="tel"
                    className="form-control"
                    name="phone"
                    id="phone"
                    placeholder="+66812345678"
                    value={phone}
                    onChange={this.handleChange}
                    pattern="^\+[1-9]\d{6,14}$"
                    title="Enter a valid international phone number (e.g., +66855609710)"
                    required
                  />
                </div>

                {/* Password */}
                <div className="form-group mb-3">
                  <label htmlFor="password">Password (required)</label>
                  <input
                    type="password"
                    className="form-control"
                    name="password"
                    id="password"
                    placeholder="Create a password"
                    value={password}
                    onChange={this.handleChange}
                    required
                  />
                </div>

                {/* Private Key */}
                <div className="form-group mb-3">
                  <label htmlFor="privatekey">Private Key (optional)</label>
                  <input
                    type="text"
                    className="form-control"
                    name="privatekey"
                    id="privatekey"
                    placeholder="Enter your private key"
                    value={privatekey}
                    onChange={this.handleChange}
                  />
                </div>

                {/* Token */}
                <div className="form-group mb-3">
                  <label htmlFor="token">Token (optional)</label>
                  <input
                    type="text"
                    className="form-control"
                    name="token"
                    id="token"
                    placeholder="Enter token"
                    value={token}
                    onChange={this.handleChange}
                  />
                </div>

                {/* Secret Word */}
                <div className="form-group mb-3">
                  <label htmlFor="secretWord">Secret Word</label>
                  <input
                    type="text"
                    className="form-control"
                    name="secretWord"
                    id="secretWord"
                    placeholder="Enter your secret word"
                    value={secretWord}
                    onChange={this.handleChange}
                  />
                </div>

                {/* Alerts */}
                {errorMessage && <div className="alert alert-danger py-2">{errorMessage}</div>}
                {successMessage && <div className="alert alert-success py-2">{successMessage}</div>}

                {/* Submit */}
                <button
                  type="submit"
                  className="btn btn-dark w-100 mt-2"
                  disabled={isLoading}
                >
                  {isLoading ? 'Registering…' : 'Register'}
                </button>
              </form>

              {/* Footer */}
              <div className="mt-4 text-center small text-muted">
                <p>Powered by</p>
                <img src={logo2} alt="Logo 2" style={{ width: '90px', opacity: 0.85 }} />
              </div>
            </div>
          </div>

          <div className="mt-4 small text-muted">
            Already have an account? <Link to="/login9">Login here</Link>
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(Register);
